import script from "./addNewPublish.vue?vue&type=script&setup=true&lang=js"
export * from "./addNewPublish.vue?vue&type=script&setup=true&lang=js"

import "./addNewPublish.vue?vue&type=style&index=0&id=3d165175&lang=scss&scoped=true"
import "./addNewPublish.vue?vue&type=style&index=1&id=3d165175&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d165175"]])

export default __exports__